import { useState } from "react";
import Logo from '../../assets/logo.png';
import { AppMode, dark_mode_primary } from "../values";
import { Link } from "react-router-dom/cjs/react-router-dom";

export function Header({ appMode }) {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
    const headerColour = () => {
        if (window.location.pathname === '/user') {
            return appMode === AppMode.DARK ? dark_mode_primary + ' text-white' : 'text-black';
        }
        return '';
    };
    return (
        <header className={`relative p-7 ${headerColour()}`}>
            <div className="mx-auto flex justify-between items-center">
                <Link to="/"><img className="w-auto h-10" src={Logo} alt="" /></Link>
                <div className="hidden md:flex items-center">
                    <Link to="/product" className={`px-2.5 py-2 text-lg transition-colors duration-300 transform rounded-md hover:bg-gray-100 hover:text-black md:mx-2`}>Product</Link>
                    <Link to="/" className={`px-2.5 py-2 text-lg transition-colors duration-300 transform rounded-md hover:bg-gray-100 hover:text-black md:mx-2`}>Resources</Link>
                    <Link to="/" className={`px-2.5 py-2 text-lg transition-colors duration-300 transform rounded-md hover:bg-gray-100 hover:text-black md:mx-2`}>Download</Link>
                    <Link to="/pricing" className={`px-2.5 py-2 text-lg transition-colors duration-300 transform rounded-md hover:bg-gray-100 hover:text-black md:mx-2`}>Pricing</Link>
                </div>
                <div className="md:hidden">
                    <button type="button" className="text-gray-500 hover:text-black focus:outline-none focus:text-black" aria-label="toggle menu" onClick={toggleMenu}>
                        {isMenuOpen
                            ? <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
                            : <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M4 8h16M4 16h16" /></svg>
                        }
                    </button>
                </div>
            </div>
            <div className={`md:hidden absolute inset-x-0 z-20 w-full px-6 py-4 transition-all duration-300 ease-in-out ${isMenuOpen ? 'translate-x-0 opacity-100' : 'opacity-0 -translate-x-full'}`}>
                <div className="flex flex-col px-2 -mx-4">
                    <Link to="/product" className={`px-2.5 py-2 text-lg transition-colors duration-300 transform rounded-md hover:bg-gray-100 hover:text-black md:mx-2`}>Product</Link>
                    <Link to="/" className={`px-2.5 py-2 text-lg transition-colors duration-300 transform rounded-md hover:bg-gray-100 hover:text-black md:mx-2`}>Resources</Link>
                    <Link to="/" className={`px-2.5 py-2 text-lg transition-colors duration-300 transform rounded-md hover:bg-gray-100 hover:text-black md:mx-2`}>Download</Link>
                    <Link to="/pricing" className={`px-2.5 py-2 text-lg transition-colors duration-300 transform rounded-md hover:bg-gray-100 hover:text-black md:mx-2`}>Pricing</Link>
                </div>
            </div>
        </header>
    );
}